angular.module("rightPaneModule")
    .directive("dblActivityFeed", ['authentication', function(authentication) {
        return {
            restrict: "E",
            templateUrl: '/resources/right-pane/components/activity-feed/dbl-activity-feed.directive.html',
            scope: {
                dblActivities: '=',
                dblNoDataMessage: '=',
                dblShowSpinner: '=',
                dblShowStudentNames: '='
            },
            link: function(scope) {
                // An ID targeted toward test automation.
                // TODO: would a service help to create consistent ids across components?
                scope.getId = function (activity) {
                    var id = 'DBL_ACTIVITY_' + activity.uid;
                    return id;
                };

                scope.useBts2020Nav = authentication.useBts2020Nav;
            }
        };
    }]);
